import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import EmojiPicker from "emoji-picker-react";
import { useForm } from "react-hook-form";
import Cookies from "js-cookie";
import "boxicons";
import { CommentInsert, GetComment } from "../../apis/api/TimelineApi";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Lodderr from "../../components/Lodder/Lodder";
import "./CommentBox.css";

const CommentModal = ({ show, handleClose, data }) => {
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const userid = Cookies.get("userID");
  const companyid = Cookies.get("company_id");
  const access = JSON.parse(Cookies.get("access"));

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    const fetchComments = async () => {
      if (data?.company_post_id) {
        await dispatch(GetComment({ postId: data.company_post_id }));
      }
    };

    fetchComments();

    const interval = setInterval(fetchComments, 5000);

    return () => clearInterval(interval);
  }, [dispatch, data?.company_post_id]);

  const onSubmit = async (formData) => {
    const payload = new FormData();
    payload.append("comment", formData.comment);
    payload.append("member_id", userid);
    payload.append("company_id", companyid);
    payload.append("company_post_id", data?.company_post_id);

    const response = await dispatch(CommentInsert(payload));
    if (response?.payload?.status == "success") {
      await dispatch(GetComment({ postId: data?.company_post_id }));
      toast.success("comment inserted succesfully ...");
    } else {
      toast.error("error while inserting comment ...");
    }

    reset();
    setShowEmojiPicker(false);
  };

  const { getcomments, loading } = useSelector((state) => state.TimelineSlice);

  const addEmoji = (emojiObject) => {
    const currentComment = getValues("comment") || "";
    const updatedComment = currentComment + emojiObject.emoji;
    setValue("comment", updatedComment);
    setShowEmojiPicker(false);
  };

  const renderMedia = () => {
    if (!data?.file_url || !data?.file_extension) return null;
    const ext = data.file_extension.toLowerCase();

    if (ext === "image") {
      return (
        <>
          <img
            src={data.file_url}
            alt="Post media"
            className="img-fluid rounded shadow"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src =
                process.env.PUBLIC_URL + "/company-logo-design.jpg";
            }}
          />

          <p className="text-muted small  p-3 bg-white">
            {data?.text || "No description"}
          </p>
        </>
      );
    }

    if (ext === "video") {
      return (
        <video controls className="w-100 rounded shadow">
          <source src={data.file_url} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );
    }

    if (ext === "audio") {
      return (
        <audio controls className="w-100 mt-3">
          <source src={data.file_url} type="audio/mpeg" />
          Your browser does not support the audio tag.
        </audio>
      );
    }

    return null;
  };

  const hasMedia = data?.file_url && data?.file_extension;

  return (
    <>
      {loading && <Lodderr />}
      <Modal show={show} onHide={handleClose} size="lg" centered contentClassName="cb-modal">
        <Modal.Header closeButton>
          <Modal.Title>Comments</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="cb-layout">
            {hasMedia && (
              <div className="cb-media">
                {renderMedia()}
              </div>
            )}

            <div className="cb-thread">
              <div className="cb-list" role="list">
                {(getcomments?.data || []).length > 0 ? (
                  getcomments.data.map((item, index) => (
                    <div key={index} className="cb-item" role="listitem">
                      <img
                        src={item.member_logo || process.env.PUBLIC_URL + "/dummy-profile.png"}
                        alt="Profile"
                        className="cb-avatar"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = process.env.PUBLIC_URL + "/dummy-profile.png";
                        }}
                      />
                      <div className="cb-bubble">
                        <div className="cb-meta">
                          <span className="cb-name">{item.member_name || "Member"}</span>
                          <span className="cb-time">
                            {item.created_at ? new Date(item.created_at * 1000).toLocaleString() : ""}
                          </span>
                        </div>
                        <div className="cb-text">{item.comment}</div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="cb-empty">
                    <i className="bx bx-message-square-dots"></i>
                    <p>No comments yet. Start the conversation.</p>
                  </div>
                )}
              </div>

              {(access.comment_feed && access.comment_feed === "1") && (
                <Form onSubmit={handleSubmit(onSubmit)} className="cb-compose">
                  <Form.Control
                    type="text"
                    className="cb-input"
                    placeholder="Write a comment..."
                    {...register("comment", { required: true })}
                  />
                  <button
                    type="button"
                    className="cb-emoji-btn"
                    onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                    aria-label="Emoji"
                  >
                    <i className="bx bx-smile"></i>
                  </button>
                  <button type="submit" className="cb-send-btn">
                    <i className="bx bx-paper-plane"></i>
                    <span>Post</span>
                  </button>

                  {showEmojiPicker && (
                    <div className="cb-emoji-pop">
                      <EmojiPicker onEmojiClick={addEmoji} />
                    </div>
                  )}
                  {errors.comment && (
                    <p className="cb-error">Comment is required.</p>
                  )}
                </Form>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CommentModal;
